import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import StructuredData from "@/components/StructuredData";
import { getFAQPageSchema } from "@/utils/seoSchemas";

interface FAQ {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  questions: FAQ[];
  companyName?: string;
}

const FAQSection = ({ questions, companyName }: FAQSectionProps) => {
  const faqSchema = getFAQPageSchema(questions);

  return (
    <>
      <StructuredData data={faqSchema} />
      <section className="py-16 sm:py-20 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 sm:mb-8 lg:mb-10">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-2 sm:mb-3">
            Häufig gestellte Fragen
          </h2>
          {companyName && (
            <p className="text-sm sm:text-base text-muted-foreground">
              Alles Wichtige zur {companyName} Cyberversicherung
            </p>
          )}
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {questions.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left text-sm sm:text-base font-semibold hover:no-underline py-4">
                  <span className="pr-4">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
    </>
  );
};

export default FAQSection;
